import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78742211"),n=n(),_popScopeId(),n)
const _hoisted_1 = { align: "center" }
const _hoisted_2 = {
  key: 0,
  class: "mt-2",
  style: {"white-space":"normal"}
}
const _hoisted_3 = {
  key: 1,
  class: "mt-2",
  style: {"white-space":"normal"}
}
const _hoisted_4 = {
  class: "mt-2",
  style: {"white-space":"normal"}
}
const _hoisted_5 = { class: "d-flex align-center justify-center fill-height" }
const _hoisted_6 = { class: "mt-5" }
const _hoisted_7 = { class: "d-flex align-center justify-center fill-height" }
const _hoisted_8 = {
  class: "d-flex py-3 justify-space-between",
  style: {"height":"80px"}
}

import { useI18n } from "vue-i18n"
import { computed, onBeforeUnmount, onMounted, ref } from "vue"
import { Doctor } from "@/types"
import { specialtiesReverseMap } from "../../../types/spec"

export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorCard',
  props: {
    doctor: {}
  },
  setup(__props: any) {

const prop = __props

const { t } = useI18n()
const smallWindow = ref(window.innerWidth < 1000)
const locale = ref<string | null>(localStorage.getItem("locale"))
const openDocLocation = (): void => {
  const address = prop.doctor.clinicStreet.split(" ")

  window.open(
    `https://www.google.com/maps/search/${address[0] ?? ""}+${
      address[1] ?? ""
    }+${prop.doctor.clinicLocation ?? ""}+${prop.doctor.clinicLand}`,
    "_blank"
  )
}

onMounted(async () => {
  window.addEventListener("locale-changed", updateLocale)
})

onBeforeUnmount(() => {
  window.removeEventListener("locale-changed", updateLocale)
})

const updateLocale = () => {
  locale.value = localStorage.getItem("locale") ?? "de"
}

const spec = computed((): string => {
  if (locale.value !== "de") {
    return specialtiesReverseMap[prop.doctor.specialty]
  }
  return prop.doctor.specialty
})

const toDoctorLink = (): void => {
  const headerLink = prop.doctor.linkedInLink.split(":", 1)
  const wwwLink = prop.doctor.linkedInLink.split(".", 1)
  console.log(headerLink)
  if (headerLink[0] == "https") {
    window.open(prop.doctor.linkedInLink, "_blank")
  } else if (wwwLink[0] == "www") {
    window.open("https://" + prop.doctor.linkedInLink, "_blank")
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_hover = _resolveComponent("v-hover")!

  return (_openBlock(), _createBlock(_component_v_hover, null, {
    default: _withCtx(({ isHovering, props }) => [
      _createVNode(_component_v_card, _mergeProps({
        class: "mx-auto my-5 ml-3 mr-3",
        width: !smallWindow.value ? 400 : 300
      }, props, {
        height: "400",
        elevation: isHovering ? 20 : 3
      }), {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, {
            title: 
            prop.doctor.title +
            ' ' +
            prop.doctor.firstName +
            ' ' +
            prop.doctor.lastName
          ,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/doctors/${prop.doctor._id}`))),
            style: {"cursor":"pointer"}
          }, {
            subtitle: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (!prop.doctor.hospitalDetails)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(spec.value), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createTextVNode(_toDisplayString(prop.doctor?.hospitalDetails[0]?.name) + " ", 1),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(prop.doctor?.hospitalDetails[0]?.department), 1)
                    ]))
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_v_row, {
            align: "center",
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_badge, { color: "white" }, _createSlots({
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        width: "150",
                        style: {"border-radius":"50%","cursor":"pointer"},
                        src: 
                  prop.doctor.photo ??
                  require('../../../assets/profile_def.png')
                ,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/doctors/${prop.doctor._id}`)))
                      }, {
                        placeholder: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_v_progress_circular, {
                              color: "#3fb984",
                              indeterminate: ""
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["src"])
                    ]),
                    _: 2
                  }, [
                    (_ctx.doctor.universityLogo && !_ctx.doctor.isHospitalConnected)
                      ? {
                          name: "badge",
                          fn: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_v_img, {
                                width: "50",
                                style: {"border-radius":"50%"},
                                src: prop.doctor.universityLogo
                              }, {
                                placeholder: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_v_progress_circular, {
                                      color: "#3fb984",
                                      indeterminate: ""
                                    })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["src"])
                            ])
                          ]),
                          key: "0"
                        }
                      : (prop.doctor?.isHospitalConnected)
                        ? {
                            name: "badge",
                            fn: _withCtx(() => [
                              _createElementVNode("div", { class: "mt-5" }, [
                                _createVNode(_component_v_img, {
                                  width: "55",
                                  style: {"border-radius":"50%","cursor":"pointer"},
                                  src: 
                      prop.doctor?.hospitalDetails[0]?.photo != '' &&
                      prop.doctor?.hospitalDetails[0]?.photo
                        ? prop.doctor?.hospitalDetails[0]?.photo
                        : require('../../../assets/hospital.png')
                    ,
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push(`hospital/${_ctx.doctor.hospitalId[0]}`)))
                                }, {
                                  placeholder: _withCtx(() => [
                                    _createElementVNode("div", { class: "d-flex align-center justify-center fill-height" }, [
                                      _createVNode(_component_v_progress_circular, {
                                        color: "#3fb984",
                                        indeterminate: ""
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["src"])
                              ])
                            ]),
                            key: "1"
                          }
                        : undefined
                  ]), 1024)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_btn, {
              class: "ml-5",
              icon: "mdi-map-marker",
              size: "small",
              onClick: openDocLocation
            }),
            _createVNode(_component_v_list_item_subtitle, { class: "mt-5" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(prop.doctor.clinicLocation + ", " + prop.doctor.clinicLand), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_v_btn, {
                disabled: !_ctx.doctor.linkedInLink,
                class: "mr-5",
                icon: "mdi-web",
                size: "small",
                onClick: toDoctorLink
              }, null, 8, ["disabled"])
            ])
          ]),
          _createVNode(_component_v_card_actions, { style: {"background-color":"#3fb984","position":"absolute","bottom":"0","width":"100%"} }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                color: "white",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push(`/doctors/${prop.doctor._id}`)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("doctor.to-profile")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 2
      }, 1040, ["width", "elevation"])
    ]),
    _: 1
  }))
}
}

})